import React, { useEffect, useState } from 'react'
import Breadcrumbs from '../../common/breadcrumb/Breadcrumbs'
import PackgesSearch from './PackgesSearch'
import { getDataPacage, getDataPacageSales } from '../../api/login/Login'
import PackesSalesLists from './PackesSalesLists'
import { toast } from 'react-toastify'

function PackgesListSales() {
  const breadCrumbsTitle = {
    id: "1",
    title_1: "Master",
    title_2: "Package-Sales",
  }
  const [count, setCount] = useState(10)
  const [resetKey , setResetkey] = useState(false)
  const [page, setPage] = useState(0)
  const [aepsData, setAepsData] = useState()
  const [loading, setLoading] = useState(false)
  const [userData, setUserData] = useState(false)
  const [totalCount, setTotalCount] = useState()
  const token = window.localStorage.getItem('userToken')
  const [initialValues, setIntialValues] = useState({
      package_id :''
  })
  const toastErrorMessage = (message) => {
    toast.error(`Please Try Again ${message}`, {
      position: "top-right",
    });
  };

  const getDmtTxnData = async () => {
    let body = {
      page ,
      count,
      user_id : token,
      package_id : initialValues.package_id
    }

    setLoading(true)
    try {
      const res = await getDataPacageSales(body);
      console.log(res);
      setAepsData(res?.data);
      setTotalCount(res?.totalCount)

      // toastErrorMessage(res?.message)
      setLoading(false)
    } catch (error) {
      toastErrorMessage(error.message)
    }
    setLoading(false)
  }

  const onChangeVal = (e) => {
    setPage(e - 1)
  };




  useEffect(() => {
    getDmtTxnData()
  }, [resetKey , page])
  return (
    <>
      <Breadcrumbs breadCrumbsTitle={breadCrumbsTitle} />
      <PackgesSearch setPage={setPage} setResetkey={setResetkey} initialValues={initialValues} setIntialValues={setIntialValues} userData={userData}  aepsData={aepsData} />
      <PackesSalesLists onChangeVal={onChangeVal} aepsData={aepsData} page={page} count={count} getDmtTxnData={getDmtTxnData} totalCount={totalCount} loading={loading}/>
    </>
  )
}

export default PackgesListSales
